import { Routes, Route } from 'react-router'
import { RootLayout } from './layouts/root-layout'

import { IndexRedirect } from './lib/auth/index-redirect'
import LoginPage from './pages/login'
import SignupPage from './pages/signup'
import DashboardPage from './pages/dashboard'
import WalletPage from './pages/wallet'
import EstimatesPage from './pages/estimates'
import EstimatesQuickPage from './pages/estimates-quick'
import EstimatesFullPage from './pages/estimates-full'
import MyEstimatesPage from './pages/my-estimates'
import ConsumerIntakeEstimatePage from './pages/consumer-intake-estimate'
import EstimateDetailPage from './pages/estimate-detail'
import EstimateEditPage from './pages/estimate-edit'
import CustomerPage from './pages/customer'
import CustomersPage from './pages/customers'
import InboxPage from './pages/inbox'
import TasksPage from "@/pages/tasks"
import SettingsPage from './pages/settings'
import ReportsPage from './pages/reports'
import PayoutsPage from './pages/payouts'
import TotalLossPage from './pages/total-loss'
import CalendarPage from './pages/calendar'
import MarketingPage from './pages/marketing'
import ReferralsPage from './pages/referrals'
import LeadersPage from './pages/leaders'
import BookPage from './pages/book'
import OnboardingPage from './pages/onboarding'
import ForgotPasswordPage from './pages/forgot-password'
import ResetPasswordPage from './pages/reset-password'
import SetPasswordPage from './pages/set-password'
import InvitePage from './pages/invite'
import WelcomePasswordPage from './pages/welcome-password'
import WelcomeProfilePage from './pages/welcome-profile'
import WelcomeTourPage from './pages/welcome-tour'
import TeamPage from './pages/team'
import ConsumerFlowPage from './pages/consumer-flow'
import ConsumerTrackPage from './pages/consumer-track'
import ActivatePage from './pages/activate'
import OnboardingLinksPage from './pages/onboarding-links'
import Dev3DTaggerPage from './pages/_dev-3d-tagger'
import UnauthorizedPage from './pages/unauthorized'
import AdminLoginPage from './pages/admin/index'
import AdminDashboardPage from './pages/admin/dashboard'

export function App() {
  return (
    <RootLayout>
      <Routes>
        <Route path="/" element={<IndexRedirect />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/invites/:uuid" element={<InvitePage />} />
        <Route path="/welcome/password" element={<WelcomePasswordPage />} />
        <Route path="/welcome/profile" element={<WelcomeProfilePage />} />
        <Route path="/welcome/role-tour" element={<WelcomeTourPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/estimates" element={<EstimatesPage />} />
        <Route path="/estimates/quick" element={<EstimatesQuickPage />} />
        <Route path="/estimates/full" element={<EstimatesFullPage />} />
        <Route path="/estimates/consumer-intake" element={<ConsumerIntakeEstimatePage />} />
        <Route path="/my-estimates" element={<MyEstimatesPage />} />
        <Route path="/estimates/:id" element={<EstimateDetailPage />} />
        <Route path="/estimates/:id/edit" element={<EstimateEditPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/customers/:id" element={<CustomerPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/account" element={<SettingsPage />} />
        <Route path="/settings/:kind/:teamId/:section" element={<SettingsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/payouts" element={<PayoutsPage />} />
        <Route path="/total-loss" element={<TotalLossPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/marketing" element={<MarketingPage section="today" />} />
        <Route path="/marketing/contacts" element={<MarketingPage section="contacts" />} />
        <Route path="/marketing/contacts/:contactId" element={<MarketingPage section="contact" />} />
        <Route path="/marketing/conversations" element={<MarketingPage section="conversations" />} />
        <Route path="/marketing/pipeline" element={<MarketingPage section="pipeline" />} />
        <Route path="/marketing/analytics" element={<MarketingPage section="analytics" />} />
        <Route path="/referrals" element={<ReferralsPage />} />
        <Route path="/leaders" element={<LeadersPage />} />
        {/* Public — the customer's booking link (no login). */}
        <Route path="/book/:token" element={<BookPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/onboarding-links" element={<OnboardingLinksPage />} />
        {/* Public, no-login sales-assisted onboarding — token-gated activation. */}
        <Route path="/activate/:token" element={<ActivatePage />} />
        {/* Public, no-login consumer flow — shop-branded damage intake. */}
        <Route path="/go/:shopId" element={<ConsumerFlowPage />} />
        <Route path="/track/:trackToken" element={<ConsumerTrackPage />} />
        <Route path="/dev-3d" element={<Dev3DTaggerPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
      </Routes>
    </RootLayout>
  )
}
